(() => {
  if (window.NobleProductVideoController) return;

  const visibility = new WeakMap();
  const videos = () => [...document.querySelectorAll('[data-noble-gallery-video], [data-noble-how-to-video]')];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const pauseAll = (exception) => {
    videos().forEach((video) => {
      if (video !== exception) video.pause();
    });
  };

  const isGalleryActive = (video) => {
    const slide = video.closest('.product__media-item');
    return slide?.classList.contains('is-active') && visibility.get(video) === true;
  };

  const play = (video) => {
    if (!video || reducedMotion.matches || document.hidden) return;
    pauseAll(video);
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.play().catch(() => {});
  };

  const sync = () => {
    const activeGalleryVideo = videos().find((video) => video.matches('[data-noble-gallery-video]') && isGalleryActive(video));
    if (activeGalleryVideo) {
      play(activeGalleryVideo);
      return;
    }

    const visibleHowToVideo = videos().find((video) => video.matches('[data-noble-how-to-video]') && visibility.get(video) === true);
    if (visibleHowToVideo) play(visibleHowToVideo);
    else pauseAll();
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => visibility.set(entry.target, entry.isIntersecting && entry.intersectionRatio >= 0.55));
    sync();
  }, { threshold: [0, 0.55, 1] });

  const register = (root = document) => {
    root.querySelectorAll?.('[data-noble-gallery-video], [data-noble-how-to-video]').forEach((video) => {
      if (video.dataset.nobleVideoReady) return;
      video.dataset.nobleVideoReady = 'true';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      observer.observe(video);
    });
    root.querySelectorAll?.('.product__media-item').forEach((slide) => {
      if (slide.dataset.nobleVideoObserved) return;
      slide.dataset.nobleVideoObserved = 'true';
      new MutationObserver(sync).observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
    sync();
  };

  document.addEventListener('visibilitychange', sync);
  document.addEventListener('click', (event) => {
    if (event.target.closest('thumbnail-slider, product-gallery, media-gallery')) requestAnimationFrame(sync);
  });
  document.addEventListener('shopify:section:load', (event) => register(event.target));
  reducedMotion.addEventListener?.('change', sync);
  window.NobleProductVideoController = { register, sync };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => register());
  else register();
})();
